import { render, staticRenderFns } from "./TypingBalloon.vue?vue&type=template&id=f105b9ce&scoped=true&"
import script from "./TypingBalloon.vue?vue&type=script&lang=js&"
export * from "./TypingBalloon.vue?vue&type=script&lang=js&"
import style0 from "./TypingBalloon.vue?vue&type=style&index=0&id=f105b9ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f105b9ce",
  null
  
)

export default component.exports